var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPkgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 375 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "missing info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0.236933921,
    y: 0,
    width: 375,
    height: 160
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 375,
    height: 160
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-information",
    transform: "translate(0.000000, -120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pkgNotFound",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.8,
    fill: "#00A9CE",
    x: 0.236933921,
    y: 0,
    width: 375,
    height: 160
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pattern",
    mask: "url(#mask-2)",
    fill: "#00A9CE",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(187.500000, 79.898879) rotate(-14.000000) translate(-187.500000, -79.898879) translate(-24.000000, -131.101121)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "180.810241 421.288044 181.802083 421.288044 421.810241 182.27577 421.810241 181.288044"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "200.760337 420.983176 201.752708 420.983176 421.760337 201.970361 421.760337 200.983176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "220.831393 420.693161 221.823634 420.693161 421.831393 220.685401 421.831393 219.693161"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "240.539567 421.35859 241.53207 421.35859 421.539567 241.351094 421.539567 240.35859"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "261.595771 420.189536 262.582439 420.189536 421.595771 261.176553 421.595771 260.189536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "281.303944 420.854964 282.290508 420.854964 421.303944 281.84118 421.303944 280.854964"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "301.239188 420.671058 302.233013 420.671058 422.239188 301.657016 422.239188 300.671058"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "321.068322 421.351339 322.063287 421.351339 422.068322 321.345952 422.068322 320.351339"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "341.018418 421.046472 342.014218 421.046472 422.018418 341.04262 422.018418 340.046472"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    points: "162.087216 420.743576 163.075105 420.743576 422.087216 161.731465 422.087216 160.743576"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    points: "141.272933 420.942334 142.26449 420.942334 422.272933 140.933892 422.272933 139.942334"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    points: "121.322838 421.247202 122.314282 421.247202 422.322838 121.238645 422.322838 120.247202"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    points: "100.281486 421.295295 101.27283 421.295295 421.281486 102.2839 421.281486 101.295295"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    points: "80.573312 420.629866 81.5649182 420.629866 421.573312 81.6182158 421.573312 80.6298661"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    points: "60.6232166 420.934733 61.6147457 420.934733 421.623217 61.9231662 421.623217 60.9347333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    points: "41.9001909 420.390266 42.8890478 420.390266 421.900191 41.3784244 421.900191 40.3902657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    points: "21.0859085 420.589024 22.0773048 420.589024 422.085909 20.5797203 422.085909 19.589024"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    points: "421.518774 0.879039052 1.01485214 420.384139 1.01485214 420.879039 1.51093047 420.879039 422.014852 1.37393905 422.014852 0.879039052"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    points: "400.952751 1.16905408 0.943795743 401.178007 0.943795743 402.169054 401.943796 1.16905408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    points: "381.111303 1.60973434 2.09980911 380.621576 2.09980911 381.609734 382.099809 1.60973434"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    points: "361.415309 0.823344833 1.40648769 359.834562 1.40648769 360.823345 362.406488 0.823344833"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    points: "341.465136 1.128212 1.45639225 340.140211 1.45639225 341.128212 342.456392 1.128212"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    points: "320.544306 1.19115727 0.536001076 320.202552 0.536001076 321.191157 321.536001 1.19115727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    points: "300.715423 0.51087658 0.706866577 300.519433 0.706866577 301.510877 301.706867 0.51087658"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    points: "280.764864 0.815743749 0.756771131 280.823837 0.756771131 281.815744 281.756771 0.815743749"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    points: "260.924895 1.256424 1.9127845 260.268535 1.9127845 261.256424 261.912784 1.256424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    points: "240.98535 1.44033022 0.977541187 240.452604 0.977541187 241.44033 241.977541 1.44033022"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    points: "221.277347 0.774901666 1.26936764 219.787717 1.26936764 220.774902 222.269368 0.774901666"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    points: "201.206074 1.0649167 1.19831124 201.073027 1.19831124 202.064917 202.198311 1.0649167"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    points: "181.255363 1.36978387 1.2482158 181.37728 1.2482158 182.369784 182.248216 1.36978387"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    points: "160.447265 1.56854223 1.43393343 160.581525 1.43393343 161.568542 161.433933 1.56854223"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    points: "140.739199 0.903113668 1.72575988 139.91655 1.72575988 140.903114 141.72576 0.903113668"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    points: "120.796694 1.08701989 0.790516575 120.101062 0.790516575 121.08702 121.790517 1.08701989"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    points: "100.724495 1.37703492 0.719460181 101.382418 0.719460181 102.377035 101.71946 1.37703492"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    points: "81.0154903 0.711606364 1.01128663 80.7158057 1.01128663 81.7116064 82.0112866 0.711606364"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "boxes",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.236934, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-110",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "0 83.7989 39.306 96.9949 39.306 49.1999 0 36.0049"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#C4C2C2",
    points: "71.1334 79.4006 39.3054 96.9946 39.3054 49.1996 71.1334 31.6066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#D3D3D3",
    points: "0 36.0044 39.306 49.2004 71.133 31.6064 31.122 20.3814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#1F408F",
    points: "55.2194 88.1974 57.7324 75.5824 71.1334 68.3244 71.1334 79.4004"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#E93232",
    points: "55.2194 76.9015 53.0064 89.4205 48.0904 92.1385 50.7754 79.1405"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#1F408F",
    points: "51.6544 26.1418 39.3054 29.1788 63.1764 36.0048 71.1334 31.6058"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#E93232",
    points: "48.8639 25.3591 37.2799 28.1521 32.8809 26.7551 44.0359 24.0051"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    points: "45.3649 52.1794 66.4309 40.6524 66.4309 62.7534 45.1659 73.4444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#000000",
    points: "58.5133 61.1379 58.5133 55.7249 59.8753 54.9769 59.8753 60.3929"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#000000",
    points: "49.2526 66.0256 49.2526 60.6126 50.6136 59.8646 50.6136 65.2806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#000000",
    points: "50.7924 59.7626 50.7924 65.1756 51.4734 64.8036 51.4734 59.3886"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#000000",
    points: "51.6186 59.3279 51.6186 64.7409 51.9586 64.5549 51.9586 59.1389"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#000000",
    points: "52.1982 59.0552 52.1982 64.4682 52.5382 64.2812 52.5382 58.8662"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#000000",
    points: "52.7805 58.6817 52.7805 64.0947 53.4605 63.7217 53.4605 58.3057"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#000000",
    points: "53.6058 58.2461 53.6058 63.6591 53.9458 63.4721 53.9458 58.0571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#000000",
    points: "54.1854 57.9734 54.1854 63.3864 54.5254 63.1994 54.5254 57.7844"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#000000",
    points: "54.7182 57.6872 54.7182 63.1002 55.3982 62.7282 55.3982 57.3122"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#000000",
    points: "55.5435 57.2525 55.5435 62.6655 55.8835 62.4785 55.8835 57.0635"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#000000",
    points: "56.1231 56.9798 56.1231 62.3928 56.4631 62.2058 56.4631 56.7908"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#000000",
    points: "56.6055 56.7188 56.6055 62.1318 57.2865 61.7588 57.2865 56.3438"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#000000",
    points: "57.4317 56.2841 57.4317 61.6971 57.7717 61.5101 57.7717 56.0951"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#000000",
    points: "58.0113 56.0105 58.0113 61.4235 58.3513 61.2375 58.3513 55.8215"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "139.7316 116.612 100.4266 103.417 100.4266 15.623 139.7316 28.818"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#C4C2C2",
    points: "171.5597 99.0182 139.7317 116.6122 139.7317 28.8182 171.5597 11.2242"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#D3D3D3",
    points: "131.5476 -0.0001 100.4266 15.6229 139.7316 28.8179 171.5596 11.2249"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#1F408F",
    points: "155.6456 107.8151 158.1586 95.2001 171.5596 87.9421 171.5596 99.0181"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#E93232",
    points: "155.6456 96.5197 153.4326 109.0387 148.5166 111.7567 151.2016 98.7587"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#1F408F",
    points: "152.0812 5.7599 139.7312 8.7969 163.6022 15.6229 171.5602 11.2239"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#FFFFFF",
    points: "145.7911 31.7975 166.8571 20.2705 166.8571 82.3715 145.5931 93.0625"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#000000",
    points: "158.9396 80.756 158.9396 75.343 160.3016 74.595 160.3016 80.011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#000000",
    points: "149.6788 85.6437 149.6788 80.2307 151.0408 79.4827 151.0408 84.8977"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#000000",
    points: "151.2198 79.3808 151.2198 84.7938 151.8998 84.4218 151.8998 79.0068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#000000",
    points: "152.0451 78.9461 152.0451 84.3591 152.3861 84.1731 152.3861 78.7571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#000000",
    points: "152.6238 78.6734 152.6238 84.0864 152.9648 83.8994 152.9648 78.4844"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#000000",
    points: "153.207 78.299 153.207 83.712 153.887 83.34 153.887 77.924"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#000000",
    points: "154.0323 77.8643 154.0323 83.2773 154.3733 83.0903 154.3733 77.6753"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#000000",
    points: "154.611 77.5907 154.611 83.0037 154.952 82.8177 154.952 77.4027"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#000000",
    points: "155.1447 77.3054 155.1447 82.7184 155.8247 82.3464 155.8247 76.9304"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#000000",
    points: "155.97 76.8707 155.97 82.2837 156.311 82.0967 156.311 76.6817"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#000000",
    points: "156.5487 76.5971 156.5487 82.0111 156.8897 81.8241 156.8897 76.4091"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#000000",
    points: "157.032 76.337 157.032 81.75 157.713 81.377 157.713 75.962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#000000",
    points: "157.8582 75.9023 157.8582 81.3153 158.1982 81.1283 158.1982 75.7133"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#000000",
    points: "158.4378 75.6287 158.4378 81.0417 158.7768 80.8547 158.7768 75.4397"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#FFFFFF",
    points: "193.4493 144.5358 154.1433 131.3408 154.1433 83.5468 193.4493 96.7418"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#C4C2C2",
    points: "193.4496 96.7418 193.4496 144.5358 225.2776 126.9418 225.2776 79.1478"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#D3D3D3",
    points: "154.1439 83.5469 193.4499 96.7419 225.2769 79.1479 185.2659 67.9239"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#1F408F",
    points: "211.8762 123.1235 209.3632 135.7385 225.2772 126.9425 225.2772 115.8665"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#E93232",
    points: "209.3634 124.443 207.1504 136.963 202.2334 139.68 204.9194 126.682"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#1F408F",
    points: "193.4496 76.7204 217.3206 83.5474 225.2776 79.1474 205.7986 73.6824"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#E93232",
    points: "203.0079 72.9006 191.4239 75.6936 187.0259 74.2966 198.1799 71.5466"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#FFFFFF",
    points: "199.5089 99.7209 220.5749 88.1949 220.5749 110.2949 199.3109 120.9859"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#000000",
    points: "212.6573 108.6794 212.6573 103.2664 214.0183 102.5184 214.0183 107.9344"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#000000",
    points: "203.3966 113.5671 203.3966 108.1541 204.7576 107.4061 204.7576 112.8221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#000000",
    points: "204.9363 107.3051 204.9363 112.7181 205.6173 112.3451 205.6173 106.9301"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#000000",
    points: "205.7625 106.8695 205.7625 112.2825 206.1035 112.0965 206.1035 106.6815"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#000000",
    points: "206.3421 106.5968 206.3421 112.0098 206.6811 111.8228 206.6811 106.4078"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#000000",
    points: "206.9235 106.2224 206.9235 111.6354 207.6045 111.2634 207.6045 105.8474"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#000000",
    points: "207.7497 105.7877 207.7497 111.2007 208.0907 111.0147 208.0907 105.5997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#000000",
    points: "208.3293 105.515 208.3293 110.928 208.6703 110.741 208.6703 105.326"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#000000",
    points: "208.8621 105.2288 208.8621 110.6418 209.5431 110.2688 209.5431 104.8538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#000000",
    points: "209.6874 104.7941 209.6874 110.2071 210.0284 110.0211 210.0284 104.6061"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#000000",
    points: "210.267 104.5214 210.267 109.9344 210.607 109.7474 210.607 104.3324"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#000000",
    points: "210.7503 104.2604 210.7503 109.6734 211.4303 109.3004 211.4303 103.8854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-65",
    fill: "#000000",
    points: "211.5765 103.8257 211.5765 109.2387 211.9155 109.0517 211.9155 103.6367"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-66",
    fill: "#000000",
    points: "212.1543 103.5521 212.1543 108.9651 212.4953 108.7791 212.4953 103.3631"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#FFFFFF",
    points: "35.5662 153.9071 101.4932 176.0391 101.4932 95.8751 35.5662 73.7431"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#C4C2C2",
    points: "101.493 95.8751 101.493 176.0391 154.877 146.5301 154.877 66.3661"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#D3D3D3",
    points: "101.4928 95.8752 35.5668 73.7432 87.7658 47.5392 154.8768 66.3662"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#1F408F",
    points: "128.1847 161.2839 132.3997 140.1249 154.8767 127.9519 154.8767 146.5299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#1F408F",
    points: "122.2052 57.2004 101.4932 62.2934 141.5302 73.7434 154.8772 66.3664"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-72",
    fill: "#E93232",
    points: "117.5245 55.8874 98.0945 60.5724 90.7165 58.2294 109.4255 53.6154"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-109",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(51.000000, 81.039000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8356,31.4211 C28.8356,34.8161 27.6246,37.5681 26.1306,37.5681 C24.6366,37.5681 23.4256,34.8161 23.4256,31.4211 C23.4256,28.0251 24.6366,25.2731 26.1306,25.2731 C27.6246,25.2731 28.8356,28.0251 28.8356,31.4211",
    id: "Fill-73",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2413,25.2732 C7.2413,28.6692 6.0303,31.4212 4.5363,31.4212 C3.0423,31.4212 1.8313,28.6692 1.8313,25.2732 C1.8313,21.8772 3.0423,19.1252 4.5363,19.1252 C6.0303,19.1252 7.2413,21.8772 7.2413,25.2732",
    id: "Fill-75",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    fill: "#FFFFFF",
    points: "60.6564 19.8332 95.9894 0.5002 95.9894 37.5682 60.3224 55.5002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-79",
    fill: "#000000",
    points: "82.7101 34.8596 82.7101 25.7806 84.9931 24.5266 84.9931 33.6096"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-81",
    fill: "#000000",
    points: "67.1769 43.0574 67.1769 33.9784 69.4599 32.7244 69.4599 41.8074"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-83",
    fill: "#000000",
    points: "69.7599 41.6326 69.7599 32.5536 70.9019 31.9246 70.9019 41.0076"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-85",
    fill: "#000000",
    points: "71.1456 40.9035 71.1456 31.8245 71.7156 31.5075 71.7156 40.5915"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-87",
    fill: "#000000",
    points: "72.1163 40.4451 72.1163 31.3661 72.6873 31.0491 72.6873 40.1331"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    fill: "#000000",
    points: "73.0939 39.8176 73.0939 30.7386 74.2359 30.1096 74.2359 39.1926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-91",
    fill: "#000000",
    points: "74.4786 39.0886 74.4786 30.0096 75.0496 29.6926 75.0496 38.7766"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-93",
    fill: "#000000",
    points: "75.4503 38.6301 75.4503 29.5511 76.0203 29.2341 76.0203 38.3181"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-95",
    fill: "#000000",
    points: "76.3439 38.1511 76.3439 29.0721 77.4859 28.4431 77.4859 37.5261"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-97",
    fill: "#000000",
    points: "77.7286 37.4221 77.7286 28.3431 78.2996 28.0261 78.2996 37.1101"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-99",
    fill: "#000000",
    points: "78.7003 36.9636 78.7003 27.8846 79.2703 27.5676 79.2703 36.6516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-101",
    fill: "#000000",
    points: "79.5099 36.5261 79.5099 27.4471 80.6519 26.8181 80.6519 35.9011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-103",
    fill: "#000000",
    points: "80.8956 35.7971 80.8956 26.7181 81.4656 26.4011 81.4656 35.4851"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-105",
    fill: "#000000",
    points: "81.8663 35.3386 81.8663 26.2596 82.4373 25.9426 82.4373 35.0266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8229,60.0564 C0.8229,60.0564 1.8309,47.5564 11.9899,48.9134 C21.8219,50.2274 26.1309,60.8794 26.1309,69.3274",
    id: "Stroke-107",
    stroke: "#494949",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkgNotFound);
export default __webpack_public_path__ + "static/media/Pkg_NotFound.0350c3b7ae3390d690151f80d02ca319.svg";
export { ForwardRef as ReactComponent };